import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/deleteFilledAntDesignRed.svg'


const _hoisted_1 = { id: "city-form" }
const _hoisted_2 = { class: "title-form py-5 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 h-3",
  alt: "delete"
}, null, -1)
const _hoisted_5 = {
  class: "p-fluid px-3 ",
  style: {"height":"75vh","overflow-y":"scroll"}
}
const _hoisted_6 = { class: "p-field mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "namaAlamat" }, "Nama Alamat", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "p-error" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field mb-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "namaPenerima" }, "Nama Penerima", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-error" }
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "p-error"
}
const _hoisted_18 = { class: "p-field mb-4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "telpPenerima" }, "Telepon Penerima", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "p-error" }
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "p-error"
}
const _hoisted_24 = { class: "p-field mb-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "telpPenerima" }, "Kota", -1)
const _hoisted_26 = {
  key: 0,
  class: "p-error"
}
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { for: "address" }, "Alamat Lengkap", -1)
const _hoisted_30 = { class: "absolute top-0 " }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-map-marker " }),
  /*#__PURE__*/_createTextVNode(" Pilih alamat dengan maps")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "p-error"
}
const _hoisted_33 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_34 = { class: "p-col-12" }
const _hoisted_35 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "pi text-sm" }, "LAT", -1)
const _hoisted_37 = { class: "p-col-12" }
const _hoisted_38 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "pi text-sm" }, "LNG", -1)
const _hoisted_40 = { class: "p-field mb-4" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { for: "kodePos" }, "Kode Pos", -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "p-error"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "p-error"
}
const _hoisted_46 = { class: "p-field mb-4" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { for: "address" }, "Detail Alamat Lainnya", -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "p-error" }
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "p-error"
}
const _hoisted_52 = {
  class: "btn-action w-full",
  style: {"position":"absolute","bottom":"10px"}
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_54 = {
  id: "mapDiv",
  ref: "mapDiv",
  style: {"width":"100%","height":"70vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_GoogleAutocomplete = _resolveComponent("GoogleAutocomplete")
  const _component_Maps = _resolveComponent("Maps")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.data)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "background-red-lighten-5 p-3 rounded-md cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteData()))
          }, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("form", {
      id: "form-address-company",
      onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            id: "namaAlamat",
            class: "input-primary mt-1",
            name: "namaAlamat",
            modelValue: _ctx.v$.Alias.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.Alias.$model = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.Alias.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.Alias.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_9, [
                      _createTextVNode(_toDisplayString(error.$message), 1),
                      _hoisted_10
                    ])
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.Alias.$invalid && _ctx.submitted) || _ctx.v$.Alias.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.Alias.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputText, {
            id: "namaPenerima",
            class: "input-primary mt-1",
            name: "namaPenerima",
            modelValue: _ctx.v$.Penerima.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.Penerima.$model = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.Penerima.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_14, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.Penerima.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_15, [
                      _createTextVNode(_toDisplayString(error.$message), 1),
                      _hoisted_16
                    ])
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.Penerima.$invalid && _ctx.submitted) || _ctx.v$.Penerima.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_17, _toDisplayString(_ctx.v$.Penerima.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_InputText, {
            id: "telpPenerima",
            class: "input-primary mt-1",
            name: "telpPenerima",
            modelValue: _ctx.v$.Telepon.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.Telepon.$model = $event)),
            type: "number",
            maxlength: "14"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.Telepon.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_20, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.Telepon.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_21, [
                      _createTextVNode(_toDisplayString(error.$message), 1),
                      _hoisted_22
                    ])
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.Telepon.$invalid && _ctx.submitted) || _ctx.v$.Telepon.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_23, _toDisplayString(_ctx.v$.Telepon.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_Multiselect, {
            id: "kota",
            class: "mt-1",
            modelValue: _ctx.v$.Kota.$model,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.Kota.$model = $event)),
            placeholder: "Pilih Kota",
            options: _ctx.kotaOption,
            searchable: true
          }, null, 8, ["modelValue", "options"]),
          ((_ctx.v$.Kota.$invalid && _ctx.submitted) || _ctx.v$.Kota.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_26, _toDisplayString(_ctx.v$.Kota.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode("div", {
              class: "h-48 flex justify-center mt-2 relative items-center border-dotted  border-4 bg-yellow-100 border-yellow-500",
              onClick: _cache[6] || (_cache[6] = () => (_ctx.openMap = true))
            }, [
              _createVNode("span", _hoisted_30, _toDisplayString(_ctx.dataForm.Alamat), 1),
              _hoisted_31
            ]),
            ((_ctx.v$.Alamat.$invalid && _ctx.submitted) || _ctx.v$.Alamat.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_32, _toDisplayString(_ctx.v$.Alamat.required.$message), 1))
              : _createCommentVNode("", true),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_33, [
                _createVNode("div", _hoisted_34, [
                  _createVNode("span", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_InputText, {
                      type: "text",
                      disabled: "",
                      class: "input-primary w-full",
                      modelValue: _ctx.dataForm.Latitude,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataForm.Latitude = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode("div", _hoisted_37, [
                  _createVNode("span", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_InputText, {
                      type: "text",
                      disabled: "",
                      class: "input-primary w-full",
                      modelValue: _ctx.dataForm.Longitude,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataForm.Longitude = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_40, [
          _hoisted_41,
          _createVNode(_component_InputText, {
            id: "kodePos",
            class: "input-primary mt-1",
            name: "kodePos",
            modelValue: _ctx.v$.KodePos.$model,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.KodePos.$model = $event)),
            type: "number"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.KodePos.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_42, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.KodePos.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "",
                    key: index
                  }, [
                    (index < 2)
                      ? (_openBlock(), _createBlock("small", _hoisted_43, [
                          _createTextVNode(_toDisplayString(error.$message), 1),
                          _hoisted_44
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.KodePos.$invalid && _ctx.submitted) || _ctx.v$.KodePos.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_45, _toDisplayString(_ctx.v$.KodePos.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_46, [
          _hoisted_47,
          _createVNode(_component_Textarea, {
            id: "address",
            autocomplete: "nope",
            ref: "addressRef",
            modelValue: _ctx.v$.Note.$model,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.Note.$model = $event)),
            class: "mt-1 input-primary w-full",
            rows: "5",
            cols: "30",
            placeholder: "Detail alamat lainnya (Contoh: Blok / Unit No., Patokan)"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.Note.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_48, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.Note.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_49, [
                      _createTextVNode(_toDisplayString(error.$message), 1),
                      _hoisted_50
                    ])
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.Note.$invalid && _ctx.submitted) || _ctx.v$.Note.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_51, _toDisplayString(_ctx.v$.Note.required.$message), 1))
              : _createCommentVNode("", true)
        ])
      ])
    ], 32),
    _createVNode("div", _hoisted_52, [
      _createVNode(_component_Button, {
        label: "Simpan",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2",
        type: "submit",
        form: "form-address-company"
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_53
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_GoogleAutocomplete, {
      onSendDetail: _ctx.setAddressResult,
      event: _ctx.addressRef,
      search: _ctx.dataForm.Alamat
    }, null, 8, ["onSendDetail", "event", "search"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.openMap,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (_ctx.openMap = $event)),
      style: { width: '50vw' },
      dismissableMask: true,
      closeOnEscape: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Batal",
          icon: "pi pi-times",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openMap = false)),
          class: "p-button-text"
        })
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_54, null, 512),
        _createVNode(_component_Maps, { onSendData: _ctx.receiveMapData }, null, 8, ["onSendData"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}